module.exports = __webpack_public_path__ + "static/img/no-data-card1.37aaa7e0.png";